<template>
  <div class="page-wrap">
    <header class="header">
      <div class="top"></div>
      <div class="opera">
        <el-button icon="Back" link @click="goBack">返回 </el-button>
        <el-button type="primary" style="margin-left: 20px; margin-right: 10px" link @click="goHome">首页 </el-button>
        <span style="margin-right: 10px">></span>
        财产和行为税税源采集及合并申报
      </div>
    </header>

    <div class="content">
      <component
        :is="view"
        :data="data"
        :status="status"
        :isTaxSubmit="isTaxSubmit"
        @gotoNext="gotoNext"
        @goBack="goBack"
        @updateData="updateData"
        @taxSubmit="taxSubmit"
        @taxSubmitShow="taxSubmitShow"
      />
    </div>
  </div>
</template>

<script setup>
import { $emit, $on } from "vue-happy-bus";
import page1 from "./page1.vue";
import page2 from "./page2.vue";

const props = defineProps({
  currentQa: {
    // 当前题目信息对象
    required: true,
    type: Object,
  },
});

const views = [page1, page2];
const pageType = ref(0);
const view = shallowRef(views[pageType.value]);
const isTaxSubmit = ref(false);
const data = ref([]);
const status = ref(0);

const taxSubmitShow = () => {
  isTaxSubmit.value = true;
};

const taxSubmit = () => {
  saveData.value.status = 1;
  ElMessageBox.confirm("声明: 此表是根据国家税收法律法规及相关规定填写，本人（单位）确认填报内容真实可靠，完整，并自愿对填报内容承担法律责任。", "信息确认", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      $emit("exeSaveQa");
    })
    .catch(() => {});
};

const gotoNext = () => {
  pageType.value = pageType.value + 1;
  view.value = views[pageType.value];
};
const goBack = () => {
  if (pageType.value == 0) {
    emits("goBack");
    return;
  }

  pageType.value = pageType.value - 1;
  view.value = views[pageType.value];
};

const goHome = () => {
  emits("goHome");
};

const emits = defineEmits(["goBack", "goHome", "finish"]);

const init = () => {
  const solution = props.currentQa?.solution && JSON.parse(props.currentQa?.solution) || {};
  saveData.value = solution;
  data.value = solution.data || [];
  status.value = solution.status || 0;
};

const saveData = ref({});
const updateData = (data) => {
  if (data) {
    saveData.value = data;
    $emit("exeSaveQa");
  }
};

const getGrandchildValue = inject("getGrandchildValue");
getGrandchildValue.value.getData = () => {
  return {
    solution: JSON.stringify(saveData.value),
  };
};

// 爷爷组件，保存成功回调
$on("saveQaSuccess", (res) => {
  const solution = JSON.parse(res.serverData?.solution) || {};

  if (res.byUser) {
    ElMessageBox.alert(`${solution.status == 1 ? "提交申报" : "保存"}成功`, "提示", {
      showClose: false,
    })
      .then(() => {
        data.value = solution.data || [];
        status.value = solution.status || 0;

        if (status.value == 1) {
          emits("finish");
        } else {
          $emit("saveQaSuccessYhs");
        }
      })
      .finally(() => {});
  }
});

onMounted(() => {
  init();
});
</script>

<style scoped lang="scss">
.page-wrap {
  height: 100%;

  .header {
    .top {
      height: 56px;
      background-image: url(https://static.rhkj.com/renhe_fe/other/316.png);
      background-size: cover;
    }

    .opera {
      color: #333333;
      font-size: 14px;
      display: flex;
      align-items: center;
      height: 40px;
      padding-left: 20px;
    }
  }

  .content {
    height: calc(100% - 96px);
    background-color: #f7f8fa;
  }
}
</style>
<style lang="scss">
.fix-wrap-b {
  position: fixed;
  width: 100%;
  height: 60px;
  left: 0;
  bottom: 0;
  background-color: #ffffff;
  box-shadow: 0 -2px 5px 0 rgba(6, 13, 97, 0.102);
  display: flex;
  justify-content: center;
  transition: width 0.8s;

  > div {
    width: 1136px;
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: space-between;

    .fix-wrap-b-r {
      display: flex;
      align-items: center;
    }
  }
}

.page-wrap.show-right .fix-wrap-b {
  width: calc(100% - 400px) !important;
}
</style>
